module.exports = __webpack_public_path__ + "img/icon5-1(1).3407094f.png";